import React from 'react';
import type { SelectProps } from 'antd';

import StyledSelect from './styled.tsx';

export const BaseSelect: React.FC<SelectProps> = (props) => <StyledSelect {...props} />;
